import { Injectable } from '@angular/core'

/**
 * Used as a temporary store for the users email between the password reset pages
 */
@Injectable()
export class ResetAttributesService {
  email: string
}
